import { render, staticRenderFns } from "./microcart.vue?vue&type=template&id=748ec4fc&"
import script from "./microcart.vue?vue&type=script&lang=js&"
export * from "./microcart.vue?vue&type=script&lang=js&"
import style0 from "./microcart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports